import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/delete.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_announce_yellow.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_f_announce.svg'


const _hoisted_1 = {
  id: "booking-v4-goods-package-weight",
  "data-testid": "booking-v4-goods-package-weight",
  class: "flex flex-col gap-2"
}
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "text-xs font-semibold text-black-lp-300" }
const _hoisted_4 = {
  key: 0,
  class: "text-xs text-gray-lp-800"
}
const _hoisted_5 = { class: "border border-gray-lp-1600 rounded-lg pb-3" }
const _hoisted_6 = { class: "flex flex-row w-full py-3 px-4 gap-x-6 rounded-t-md border-b border-gray-lp-1600 text-gray-lp-300 bg-gray-lp-2800" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "w-7 font-semibold text-xs" }, " No. ", -1)
const _hoisted_8 = { class: "w-28 font-semibold text-xs" }
const _hoisted_9 = { class: "w-6/12 font-semibold text-xs" }
const _hoisted_10 = { class: "w-28 flex gap-x-1 items-center font-semibold text-xs relative" }
const _hoisted_11 = { class: "tooltip-content" }
const _hoisted_12 = { class: "flex flex-row items-center gap-x-6 px-4 py-3" }
const _hoisted_13 = { class: "w-7 text-sm text-center" }
const _hoisted_14 = { class: "w-28" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "text-black-lp-100 ml-1 bg-gray-lp-1000 px-2 py-1.5 border-l border-gray-lp-1500" }, "kg", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "w-full text-sm content-center" }, " x ", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "w-full text-sm content-center" }, " x ", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "text-black-lp-100 ml-1 bg-gray-lp-1000 px-2 py-1.5 border-l border-gray-lp-1500" }, "cm", -1)
const _hoisted_19 = { class: "w-28 text-sm" }
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 h-4.5",
  alt: "delete"
}, null, -1)
const _hoisted_21 = {
  key: 0,
  "data-testid": "booking-v4-package-weight-hws-alert",
  class: "self-start flex flex-row mx-5 mb-2 px-2 py-1 rounded-lg bg-yellow-lp-400 items-center gap-1"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "announce yellow"
}, null, -1)
const _hoisted_23 = { class: "text-yellow-lp-500 text-sm" }
const _hoisted_24 = {
  key: 1,
  class: "flex flex-row mx-5 mb-2 gap-1"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation triangle red"
}, null, -1)
const _hoisted_26 = { class: "text-red-lp-100 text-sm" }
const _hoisted_27 = {
  key: 2,
  class: "flex flex-row mx-5 mb-2 gap-1"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation triangle red"
}, null, -1)
const _hoisted_29 = { class: "text-red-lp-100 text-sm" }
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation triangle red"
}, null, -1)
const _hoisted_31 = { class: "text-red-lp-100 text-sm" }
const _hoisted_32 = {
  key: 4,
  class: "flex flex-row mx-5 mb-2 gap-1"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation triangle red"
}, null, -1)
const _hoisted_34 = { class: "text-red-lp-100 text-sm" }
const _hoisted_35 = {
  key: 5,
  class: "flex flex-row mx-5 mb-2 gap-1"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation triangle red"
}, null, -1)
const _hoisted_37 = { class: "text-red-lp-100 text-sm" }
const _hoisted_38 = {
  key: 0,
  "data-testid": "booking-v4-package-weight-one-piece-restriction",
  class: "self-start flex flex-col mt-2"
}
const _hoisted_39 = { class: "flex flex-row px-4 py-1 rounded-lg bg-blue-lp-600 items-center" }
const _hoisted_40 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "mr-2",
  alt: "announce",
  style: {"height":"24px","width":"24px"}
}, null, -1)
const _hoisted_41 = { class: "text-blue-lp-700 text-sm" }
const _hoisted_42 = {
  key: 0,
  "data-testid": "booking-v4-package-weight-error-pieces",
  class: "text-red-lp-100 text-xs"
}
const _hoisted_43 = {
  key: 1,
  class: "text-red-lp-100 text-12px flex pl-1 gap-x-2 pt-2"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("span", null, " Total berat melebihi batas maksimum. Cek & atur ulang berat. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Icons = _resolveComponent("Icons")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("bookingV4.goods.koli.title")), 1),
      (_ctx.showSubKgHelper)
        ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("bookingV4.goods.koli.infobarWeightComma")), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("bookingV4.goods.koli.grossWeight")), 1),
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("bookingV4.goods.koli.dimensions")), 1),
        _createVNode("div", _hoisted_10, [
          _createTextVNode(_toDisplayString(_ctx.$t("bookingV4.goods.koli.volumeWeight")) + " ", 1),
          _createVNode("img", {
            src: require(`@/app/ui/assets/svg/info.svg`),
            class: "h-4 w-4 cursor-pointer",
            alt: "info",
            onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTooltip($event))),
            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideTooltip($event)))
          }, null, 40, ["src"]),
          _createVNode(_component_OverlayPanel, {
            id: "package-weight-tooltip-container",
            ref: "package-weight-tooltip",
            class: "package-weight-tooltip-container",
            alignOverlay: "",
            horizontalAlign: "center",
            style: _ctx.tooltipStyle
          }, {
            default: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.packageWeightTooltipContent.title), 1),
              _createVNode("ul", _hoisted_11, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.packageWeightTooltipContent.content, (content, index) => {
                  return _withDirectives((_openBlock(), _createBlock("li", { key: index }, null, 512)), [
                    [_directive_sanitize_html, content]
                  ])
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["style"])
        ])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelValue, (piece, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          "data-testid": `booking-v4-package-weight-row-${index}`,
          class: "flex flex-col"
        }, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, _toDisplayString(index + 1), 1),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", {
                class: ["flex items-center border rounded-lg overflow-hidden", 
                piece.error.errorHws ||
                piece.error.errorMaximumGrossWeight ||
                piece.error.errorMandatoryGrossWeight
                  ? 'border-red-lp-1200'
                  : 'border-gray-lp-1500'
              ]
              }, [
                _createVNode("input", {
                  id: "booking-v4-package-weight-input-gross-weight",
                  "data-testid": 
                  `booking-v4-package-weight-input-gross-weight-${index}`
                ,
                  class: "w-full text-sm outline-none pl-2",
                  placeholder: "0",
                  maxlength: _ctx.grossWeightMaxLength(index),
                  value: _ctx.displayGrossWeight(index),
                  disabled: _ctx.disabledGrossWeight,
                  onInput: ($event: any) => (_ctx.onGrossWeightInput($event, index)),
                  onBlur: ($event: any) => (_ctx.onGrossWeightBlur(index))
                }, null, 40, ["data-testid", "maxlength", "value", "disabled", "onInput", "onBlur"]),
                _hoisted_15
              ], 2)
            ]),
            _createVNode("div", {
              class: ["w-6/12 flex flex-row gap-x-2 border rounded-lg overflow-hidden", 
              piece.error.errorMandatoryVolumeWeight
                ? 'border-red-lp-1200'
                : 'border-gray-lp-1500'
            ],
              id: "booking-v4-package-weight-input-dimension",
              "data-testid": `booking-v4-package-weight-input-dimension-${index}`
            }, [
              _createVNode("input", {
                class: "w-full pl-2 py-1.5 text-sm outline-none text-center",
                placeholder: _ctx.$t('bookingV4.goods.koli.length'),
                value: _ctx.dimensionInputValue(piece.length),
                disabled: _ctx.disabledDimension || !_ctx.enableEditSizeBasedOnWeight(piece.grossWeight),
                onInput: ($event: any) => (_ctx.onDimensionInput($event, index, 'length'))
              }, null, 40, ["placeholder", "value", "disabled", "onInput"]),
              _hoisted_16,
              _createVNode("input", {
                class: "w-full py-1.5 text-sm outline-none",
                placeholder: _ctx.$t('bookingV4.goods.koli.width'),
                value: _ctx.dimensionInputValue(piece.width),
                disabled: _ctx.disabledDimension || !_ctx.enableEditSizeBasedOnWeight(piece.grossWeight),
                onInput: ($event: any) => (_ctx.onDimensionInput($event, index, 'width'))
              }, null, 40, ["placeholder", "value", "disabled", "onInput"]),
              _hoisted_17,
              _createVNode("input", {
                class: "w-full py-1.5 text-sm outline-none",
                placeholder: _ctx.$t('bookingV4.goods.koli.height'),
                value: _ctx.dimensionInputValue(piece.height),
                disabled: _ctx.disabledDimension || !_ctx.enableEditSizeBasedOnWeight(piece.grossWeight),
                onInput: ($event: any) => (_ctx.onDimensionInput($event, index, 'height'))
              }, null, 40, ["placeholder", "value", "disabled", "onInput"]),
              _hoisted_18
            ], 10, ["data-testid"]),
            _createVNode("div", _hoisted_19, _toDisplayString(_ctx.formatWeightDisplay(piece.volumeWeight)) + " kg ", 1),
            (_ctx.modelValue.length > 1 && _ctx.canRemovePiece)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  "data-testid": `booking-v4-package-weight-button-delete-${index}`,
                  class: "text-red-lp-100 font-semibold flex items-center gap-1.5 text-sm",
                  onClick: ($event: any) => (_ctx.removePiece(index))
                }, [
                  _hoisted_20
                ], 8, ["data-testid", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          (index === 0 && _ctx.showHwsAlert && _ctx.modelValue.length === 1)
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                _hoisted_22,
                _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("bookingV4.goods.koli.alert.hws", {
                minimumWeightKg: _ctx.hwsConfig.minimumExist
                  ? _ctx.hwsConfig.minimumWeightKg
                  : 0
              })), 1)
              ]))
            : _createCommentVNode("", true),
          (piece.error.errorMandatoryGrossWeight)
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _hoisted_25,
                _createVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("bookingV4.goods.koli.error.emptyGrossWeight")), 1)
              ]))
            : _createCommentVNode("", true),
          (piece.error.errorMandatoryVolumeWeight)
            ? (_openBlock(), _createBlock("div", _hoisted_27, [
                _hoisted_28,
                _createVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("bookingV4.goods.koli.error.emptyVolumeWeight")), 1)
              ]))
            : _createCommentVNode("", true),
          (piece.error.errorHws)
            ? (_openBlock(), _createBlock("div", {
                key: 3,
                "data-testid": `booking-v4-package-weight-hws-error-${index}`,
                class: "flex flex-row mx-5 mb-2 gap-1"
              }, [
                _hoisted_30,
                _createVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("bookingV4.goods.koli.error.hwsSecondRow", {
                minimumWeightKg: _ctx.hwsConfig.minimumExist
                  ? _ctx.hwsConfig.minimumWeightKg
                  : 0
              })), 1)
              ], 8, ["data-testid"]))
            : _createCommentVNode("", true),
          (piece.error.errorMaximumGrossWeight || _ctx.isMaxTotalGrossweight || _ctx.isMaxTotalVolumeweight)
            ? (_openBlock(), _createBlock("div", _hoisted_32, [
                _hoisted_33,
                _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$t("bookingV4.goods.koli.error.maximumWeight", {
                maxKg: _ctx.maxKg
              })), 1)
              ]))
            : _createCommentVNode("", true),
          (piece.error.errorDecreasedWeight)
            ? (_openBlock(), _createBlock("div", _hoisted_35, [
                _hoisted_36,
                _createVNode("p", _hoisted_37, _toDisplayString(_ctx.$t("bookingV4.goods.koli.error.adjustWeight")), 1)
              ]))
            : _createCommentVNode("", true)
        ], 8, ["data-testid"]))
      }), 128)),
      (_ctx.isOnePieceRestriction)
        ? (_openBlock(), _createBlock("div", _hoisted_38, [
            _createVNode("div", _hoisted_39, [
              _hoisted_40,
              _createVNode("p", _hoisted_41, _toDisplayString(_ctx.$t("bookingV4.goods.koli.error.districtOnePiece")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.singlePieceOnly && _ctx.modelValue.length < _ctx.maxPieces && _ctx.canAddPiece)
        ? (_openBlock(), _createBlock("button", {
            key: 1,
            type: "button",
            "data-testid": "booking-v4-package-weight-button-add",
            disabled: _ctx.disableAddPiece || _ctx.showHwsAlert || _ctx.isMaxTotalGrossweight || _ctx.isMaxTotalVolumeweight || _ctx.hasErrorHws,
            class: ["flex items-center pl-2 gap-1 w-fit text-sm font-semibold", 
          _ctx.disableAddPiece || _ctx.showHwsAlert || _ctx.isMaxTotalGrossweight || _ctx.isMaxTotalVolumeweight || _ctx.hasErrorHws
            ? 'text-gray-lp-600 cursor-not-allowed'
            : 'text-red-lp-2400 cursor-pointer'
        ],
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addPiece && _ctx.addPiece(...args)))
          }, [
            _createVNode(_component_Icons, {
              class: ["text-red-lp-2400 w-5 h-5", 
            _ctx.disableAddPiece || _ctx.showHwsAlert || _ctx.isMaxTotalGrossweight || _ctx.isMaxTotalVolumeweight || _ctx.hasErrorHws
              ? 'text-gray-lp-600 '
              : 'text-red-lp-2400'
          ],
              name: "grey-plus"
            }, null, 8, ["class"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV4.goods.koli.button.add")), 1)
          ], 10, ["disabled"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.errors.pieces)
      ? (_openBlock(), _createBlock("div", _hoisted_42, _toDisplayString(_ctx.errors.pieces), 1))
      : _createCommentVNode("", true),
    (_ctx.isMaxChWeight)
      ? (_openBlock(), _createBlock("div", _hoisted_43, [
          _hoisted_44,
          _hoisted_45
        ]))
      : _createCommentVNode("", true)
  ]))
}